import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-94">
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-95">
        <div className="flex items-center gap-2 text-brand-600 font-heading font-bold text-2xl tracking-tight" data-id="element-96">
          <Flame className="w-7 h-7" strokeWidth={2.5} data-id="element-97" />
          <span data-id="element-98">CRUNCHY FIT</span>
        </div>

        <button onClick={scrollToOffer} className="bg-brand-600 hover:bg-brand-700 text-white px-5 py-2.5 rounded-full font-semibold text-sm transition-colors shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-99">
          Quiero el método
        </button>
      </div>
    </header>;
}